import coreNumber from "@nextories/vue-core-components/src/i18n/langs/numberFormats";

export default {
  fr: {
    ...coreNumber.fr,
    currency: {
      style: 'currency', currency: 'EUR',
    },
  },
};
